import { isMockMode, postBlast, simulateDelay } from "../../api";

export interface CreateSiteType {
	name: string;
	licenceName: string;
	subscriptionId: string;
}

export const createSite = ({
	name,
	licenceName,
	subscriptionId,
}: CreateSiteType) => {
	if (isMockMode()) {
		const testData = {
			success: true,
		};
		return simulateDelay(50, () => testData);
	}

	return postBlast(`sites/create`, {
		name,
		licenceName,
		subscriptionId,
	});
};
